import React from 'react';
import Shipping from '../Shipping/Shipping';

const Checkout: React.FC = () => {
	return <Shipping />;
};

export default Checkout;

